export const LIST_ACTIONS = {
  REPLACE_FROM_LIST: 'REPLACE_FROM_LIST',
  APPEND_ITEMS: 'APPEND_ITEMS',
  CLEAR_ALL: 'CLEAR_ALL',
  REFRESH_METADATA: 'REFRESH_METADATA',
}

function isArrayOrUndefined(value) {
  return value === undefined || Array.isArray(value)
}

export function validateShoppingListActionPayload(action) {
  const warnings = []
  if (!action || typeof action !== 'object') {
    warnings.push('Action must be an object.')
    return warnings
  }
  if (!action.type || typeof action.type !== 'string') {
    warnings.push('Action type must be a non-empty string.')
    return warnings
  }

  switch (action.type) {
    case LIST_ACTIONS.REPLACE_FROM_LIST:
    case LIST_ACTIONS.APPEND_ITEMS:
      if (!isArrayOrUndefined(action.items)) {
        warnings.push(`${action.type}: "items" should be an array when provided.`)
      }
      break
    case LIST_ACTIONS.REFRESH_METADATA:
      if (!isArrayOrUndefined(action.refreshedItems)) {
        warnings.push('REFRESH_METADATA: "refreshedItems" should be an array when provided.')
      }
      break
    case LIST_ACTIONS.CLEAR_ALL:
      break
    default:
      warnings.push(`Unknown action type "${action.type}".`)
  }

  return warnings
}

export function dispatchShoppingListAction(action, applyShoppingListUpdate) {
  if (!action || typeof action !== 'object' || typeof applyShoppingListUpdate !== 'function') return
  if (import.meta.env.DEV) {
    const warnings = validateShoppingListActionPayload(action)
    if (warnings.length > 0) {
      console.warn('[shoppingListActions] Invalid action payload (warn-only):', {
        action,
        warnings,
      })
    }
  }

  switch (action.type) {
    case LIST_ACTIONS.REPLACE_FROM_LIST:
      applyShoppingListUpdate({
        items: action.items || [],
        listId: action.listId ?? null,
        listName: action.listName ?? null,
        isRecipe: !!action.isRecipe,
        mode: 'replace',
        preserveCurrentOnSameList: !!action.preserveCurrentOnSameList,
      })
      return
    case LIST_ACTIONS.APPEND_ITEMS:
      applyShoppingListUpdate({
        items: action.items || [],
        listId: action.listId ?? null,
        listName: action.listName ?? null,
        isRecipe: !!action.isRecipe,
        mode: 'append',
      })
      return
    case LIST_ACTIONS.CLEAR_ALL:
      applyShoppingListUpdate({ mode: 'clear' })
      return
    case LIST_ACTIONS.REFRESH_METADATA:
      applyShoppingListUpdate({
        mode: 'refresh_metadata',
        refreshedItems: action.refreshedItems || [],
      })
      return
    default:
      // Unknown action type: intentionally ignored by contract.
  }
}
